import { useMutation } from "@tanstack/react-query";

import http from "../../http";
import { ADMIN_PANEL_FETCH_PENDING_REQUESTS } from "../URL";

interface IPendingRequest {
  notifyeventid?: number;
  email?: string;
  userid?: string;
  eventtypecode?: string;
  url?: string;
  event_date: string;
}

interface IAxisErrorResponse {
  response?: {
    data?: {
      userMessage?: string;
    };
  };
}

const getPendingRequest = async () => {
  const response = await http.post<IPendingRequest[]>(
    ADMIN_PANEL_FETCH_PENDING_REQUESTS
  );
  return response.data;
};

const usePendingRequests = () =>
  useMutation<IPendingRequest[], IAxisErrorResponse, void>({
    mutationKey: ["pendingRequests"],
    mutationFn: getPendingRequest,
  });

//   const usePendingRequest = () =>
//   useQuery<IPendingRequest[]>({
//     queryKey: ["pendingRequests"],
//     queryFn: getPendingRequest,
//     networkMode: "offlineFirst",
//     staleTime: Infinity,
//   });

export default usePendingRequests;
